import React from 'react';

/**
 * PublicCard — sharp-cornered, high-contrast content card.
 *
 * Structural corners are square (brutalist) to convey authority; interactive
 * cards lift and gain a red border + glow on hover.
 */
export default function PublicCard({
  icon,
  title,
  description,
  children,
  interactive = false,
  className = '',
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`group relative bg-card border border-border p-6 md:p-8 transition-[transform,border-color,box-shadow] duration-300 ${
        interactive
          ? 'hover:-translate-y-1 hover:border-primary/60 hover:shadow-[0_0_44px_-14px_hsl(var(--primary)/0.45)]'
          : ''
      } ${className}`}
    >
      {icon && (
        <div className="inline-flex items-center justify-center w-11 h-11 bg-primary/10 text-primary mb-5 transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
          {icon}
        </div>
      )}
      {title && (
        <h3 className="text-lg md:text-xl font-heading font-bold tracking-tight text-foreground">
          {title}
        </h3>
      )}
      {description && !children && (
        <p className="mt-2.5 text-sm md:text-base text-muted-foreground leading-relaxed">
          {description}
        </p>
      )}
      {children && <div className="mt-2">{children}</div>}
    </div>
  );
}
